<template>
  <div class="layout-use-of-bar-two-content" id="identidade-visual-combinando-os-assets-uso-de-barra-com-a-logo" data-search-anchor>
    <div class="descriptiom-layout-use-of-bar-two-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-two-description">{{ layoutUseOfBarTwoDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-two-description">{{ layoutUseOfBarTwoDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-two-description">{{ layoutUseOfBarTwoDescription3 }}</p>
      </div>
    </div>
    <div
      class="layout-use-of-bar-two-card-item"
      :style="{ backgroundImage: `url(${layoutUseOfBarTwoImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsUseOfBarTwoSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutUseOfBarTwoDescription1(): string {
    return this.getElementText(9, 0)
  }

  get layoutUseOfBarTwoDescription2(): string {
    return this.getElementText(9, 1)
  }

  get layoutUseOfBarTwoDescription3(): string {
    return this.getElementText(9, 2)
  }

  get layoutUseOfBarTwoImageSrc(): string {
    return this.getElementMedia(9, 3)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-use-of-bar-two-content {
  display: grid;

  width: 100%;
  max-width: 1045px;
}

.title-layout-use-of-bar-two-wrapper {
  display: flex;
  align-items: center;
  padding: 3rem;
}

.layout-use-of-bar-two-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.layout-use-of-bar-two-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-use-of-bar-two-wrapper {
  padding: 2rem 0rem 1rem 0rem;
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.layout-use-of-bar-two-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.layout-use-of-bar-two-card-item {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
